import { Injectable } from "@angular/core";

@Injectable()
export abstract class ShiftSelectable {
    abstract select(): void;
    abstract deselect(): void;
    abstract isSelected(): boolean;
}
